<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
    <v-toolbar
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            color="blue darken-3"
            dark
            app
            fixed
    >
        <v-toolbar-title>
            <v-toolbar-side-icon
                    v-if="!$store.state.toolbar.backButtonRoute"
                    @click.stop="drawer = !drawer"
            >
            </v-toolbar-side-icon>
            <v-toolbar-side-icon
                    v-if="$store.state.toolbar.backButtonRoute"
                    @click.stop="$router.push($store.state.toolbar.backButtonRoute)"
            >
                <v-icon>arrow_back</v-icon>
            </v-toolbar-side-icon>
            <span :class="['toolbar-title', 'font-weight-light', $store.state.toolbar.subTitle ? 'hidden-sm-and-down' : '']">
                {{$store.state.toolbar.title}}
            </span>
            <span v-if="$store.state.toolbar.subTitle">
                <span class="toolbar-title-divider hidden-sm-and-down"></span>
                <span class="toolbar-sub-title font-weight-regular">{{$store.state.toolbar.subTitle}}</span>
            </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
                v-if="!$store.state.toolbar.hideSearch"
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                class="hidden-xs-and-down"
                @focus="isSearchFocused = true"
                @blur="isSearchFocused = false"
        >
            <template v-slot:label>
                <div v-if="!isSearchFocused">
                    <span class="search-input-text">Search <span class="app-name-title">{{appName}}</span></span>
                </div>
            </template>
        </v-text-field>
    </v-toolbar>

    <v-navigation-drawer
            v-model="drawer"
            :clipped="$vuetify.breakpoint.lgAndUp"
            :disable-resize-watcher="true"
            :disable-route-watcher="true"
            app
        >
        <v-toolbar flat>
            <v-list>
                <v-list-tile>
                    <v-list-tile-title class="app-name-title" style="background: inherit">
                        {{appName}}
                    </v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-toolbar>

        <v-list dense>
            <template v-for="item in items">
                <v-divider v-if="item.isSeparator"></v-divider>
                <v-list-tile v-else :key="item.text"
                             :to="item.route"
                             @click="navigateTo(item)"
                >
                    <v-list-tile-avatar>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            {{ item.text }}
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </template>
        </v-list>
    </v-navigation-drawer>
    </div>
</template>

<script>
    import {IconConstants} from "@/config/IconConstants";

    export default {
        name: "Toolbar.vue",
        data: () => ({
            drawer: false,
            appName: 'TeacherSidekick',
            items: [
                {
                    icon: IconConstants.students,
                    text: 'Students',
                    route: '/students'
                },
                {
                    icon: IconConstants.tests,
                    text: 'Tests',
                    route: '/tests'
                },
                {
                    icon: IconConstants.classes,
                    text: 'Classes',
                    route: '/classes'
                },
                {
                    icon: IconConstants.reports,
                    text: 'Reports',
                    route: '/reports'
                },
                { isSeparator: true },
                {
                    icon: IconConstants.settings,
                    text: 'Settings',
                    route: 'settings'
                },
                {
                    icon: IconConstants.help,
                    text: 'Help',
                    route: 'help'
                }
            ],
            isSearchFocused: false
        }),
        mounted() {
            this.$router.afterEach((to, from) => {
                this.setToolbarOptions(to.path);
                this.drawer = false;
            });
            this.setToolbarOptions(this.$router.currentRoute.path);
        },

        methods: {
            navigateTo(item) {
                this.$router.push(item.route);
                // set toolbar title
                this.setToolbar(item.text);
            },

            setToolbarOptions(path) {
                let foundRoute = this.items.find(i => i.route === path);
                if (foundRoute) {
                    this.setToolbar(foundRoute.text);
                }
            },

            setToolbar(text) {
                this.$store.commit('setToolbarOptions', {
                    title: text,
                    hideSearch: false,
                    backButtonRoute: null
                });
            },
        }
    }
</script>

<style scoped>
    .toolbar-title {
        font-family: "Roboto", Arial, Helvetica, sans-serif;
    }
    .toolbar-sub-title {
        font-family: "Roboto", Arial, Helvetica, sans-serif;
    }

    .toolbar-title-divider {
        border-left: 1px white solid;
        padding-left: 15px;
        margin-left: 8px
    }

    .toolbar-link {
        color: inherit;
        text-decoration: inherit;
    }

    .v-navigation-drawer .v-icon {
        font-size: 1.7em!important;
    }
    .v-navigation-drawer .v-icon.fas {
        font-size: 1.5em!important;
    }


    .search-input-text {
        opacity: .5;
        color: white;
    }

    .app-name-title {
        font-family: 'Permanent Marker', cursive;
    }
</style>
